import AccountGroupRowTemplate from "./AccountGroupRowTemplate.js";
import AccountIntervalGroupRowTemplate from "./AccountIntervalGroupRowTemplate.js";
import AccountRowTemplate from "./AccountRowTemplate.js";
import FormulaRowTemplate from "./FormulaRowTemplate.js";
import GroupRowTemplate from "./GroupRowTemplate.js";
import KeyFigureRowTemplate from "./KeyFigureRowTemplate.js";
import ModelFactory from "../../../ModelFactory.js";
import PreliminaryResultRowTemplate from "./PreliminaryResultRowTemplate.js";
import RepeatingRowTemplate from "./RepeatingRowTemplate.js";
import SpacerRowTemplate from "./SpacerRowTemplate.js";
import TextRowTemplate from "./TextRowTemplate.js";

/**
 * TODO: write documentation
 */
class ReportRowTemplateFactory extends ModelFactory {
	allClasses() {
		return [
			AccountGroupRowTemplate,
			AccountIntervalGroupRowTemplate,
			AccountRowTemplate,
			FormulaRowTemplate,
			GroupRowTemplate,
			KeyFigureRowTemplate,
			PreliminaryResultRowTemplate,
			RepeatingRowTemplate,
			SpacerRowTemplate,
			TextRowTemplate,
		];
	}

	allItemClasses() {
		return this.allClasses().filter((klass) => klass.isVisible());
	}

	_getTypeFromJson(json) {
		return json.rowType;
	}
}

const reportRowTemplateFactory = new ReportRowTemplateFactory();

export default reportRowTemplateFactory;
